import { ERROR_MESSAGES, PRODUCT_NAMES } from '../constants';
import { getCurrentProduct } from '../utils';
const {
  SUITE,
  HR
} = PRODUCT_NAMES;

const throwIfNoAccessibleProducts = accessibleProducts => {
  const suiteFilteredOut = accessibleProducts.filter(name => name !== SUITE);

  if (suiteFilteredOut.length === 0) {
    throw new Error(ERROR_MESSAGES.NO_ACCESSIBLE_PRODUCTS);
  }
};

const throwIfCurrentProductIsNotAccessible = (accessibleProducts, currentProduct) => {
  if (!accessibleProducts.includes(currentProduct?.name) && !accessibleProducts.includes(currentProduct?.productName)) {
    throw new Error(ERROR_MESSAGES.GET_CURRENT_PRODUCT_NOT_ACCESSIBLE(currentProduct?.productName || currentProduct?.name));
  } // Throw error when current product is Suite but the only other product is
  // HR because we dont have anything to show for HR and thus we want to idicate
  // that suite is not accessible


  if (currentProduct?.name === SUITE && accessibleProducts.length === 2 && accessibleProducts.includes(SUITE) && accessibleProducts.includes(HR)) {
    throw new Error(ERROR_MESSAGES.GET_CURRENT_PRODUCT_NOT_ACCESSIBLE(currentProduct?.name));
  }
};

const throwIfNoAccessibleProduct = (accessibleProducts = []) => {
  throwIfNoAccessibleProducts(accessibleProducts);
  const currentProduct = getCurrentProduct(); // Allow access to any non core products

  if (!currentProduct) return;
  throwIfCurrentProductIsNotAccessible(accessibleProducts, currentProduct);
};

export default throwIfNoAccessibleProduct;
//# sourceMappingURL=throwIfNoAccessibleProduct.js.map